import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import VernandMorencyPage from "./pages/VernandMorencyPage";
import AgendaPage from "./pages/AgendaPage";
import SpeakersPage from "./pages/SpeakersPage";
import SponsorshipPage from "./pages/SponsorshipPage";
import SignupPage from "./pages/SignupPage";
import SignupSuccessPage from "./pages/SignupSuccessPage";
import NexusImpactPage from "./pages/NexusImpactPage";
import ConferenceTopicPage from "./pages/ConferenceTopicPage";
import ResearchArticlePage from "./pages/ResearchArticlePage";
import CMSAdminPage from "./pages/CMSAdminPage";
import ExperiencePage from "./pages/ExperiencePage";
import SponsorHeroBanner from "./components/SponsorHeroBanner";
import { ThemeProvider } from "./context/ThemeContext";

// Google Analytics page view tracking
function usePageTracking() {
  const location = useLocation();
  
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-TQMJE997CQ', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
}

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

// Wrapper component to use hooks inside BrowserRouter
function AppContent() {
  usePageTracking();
  
  return (
    <>
      <ScrollToTop />
      <Navigation />
      <SponsorHeroBanner />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/vernand-morency" element={<VernandMorencyPage />} />
        <Route path="/agenda" element={<AgendaPage />} />
        <Route path="/speakers" element={<SpeakersPage />} />
        <Route path="/partnerships" element={<SponsorshipPage />} />
        <Route path="/sponsorship" element={<SponsorshipPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/signup/success" element={<SignupSuccessPage />} />
        <Route path="/nexus-impact" element={<NexusImpactPage />} />
        <Route path="/conference-topic" element={<ConferenceTopicPage />} />
        <Route path="/research" element={<ResearchArticlePage />} />
        <Route path="/experience" element={<ExperiencePage />} />
        <Route path="/admin" element={<CMSAdminPage />} />
        <Route path="/management" element={<CMSAdminPage />} />
        <Route path="/cms" element={<CMSAdminPage />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    // Set default theme on initial load
    const savedTheme = localStorage.getItem('theme') || 'dim';
    const root = document.documentElement;
    root.classList.remove('light', 'dark', 'dim');
    root.classList.add(savedTheme);
    
    if (savedTheme === 'light') {
      root.style.colorScheme = 'light';
    } else {
      root.style.colorScheme = 'dark';
    }
  }, []);

  return (
    <ThemeProvider>
      <div className="App min-h-screen bg-background text-foreground">
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
